<div class="account-pause-container fx-pointer-events-auto">
    <div class="account-pause-inner fx-center-vertical">
        <div class="account-pause-icon">
            <svg class="nu-icon nu-icon-med white">
                <use xlink:href="./assets/icons/symbol-defs.svg#nu-ic-danger-fill"></use>
            </svg>
        </div>
        <div class="account-pause-text" *ngIf="isPaused | async">
            <span>
                {{translate.get( 'ACCOUNT_PAUSED_MESSAGES.HEADER_MSG_PART1_SUB2' )|async}}   
            </span>
            <span>
                <b><a class="account-pause-auth-link white" (click)="showClosePage()">{{translate.get( 'ACCOUNT_PAUSED_MESSAGES.BUTTONS' )|async}}</a></b>  
            </span>
        </div>
        <div class="account-pause-text" *ngIf="!(isPaused | async)">
            <span>
                {{translate.get( 'ACCOUNT_PAUSED_MESSAGES.HEADER_MSG_PART1_SUB3' )|async}}   
            </span>
            <span>
                <b><a class="account-pause-auth-link white" (click)="showClosePage()">{{translate.get( 'ACCOUNT_PAUSED_MESSAGES.BUTTONS' )|async}}</a></b>  
            </span>
        </div>
    </div>
</div>
